<div class="layout-container">
  <app-side-menu
    [rootRoutes]="rootRoutes"
    [organizationRoutes]="organizationRoutes"
    (menuClick)="goTo($event)">
  </app-side-menu>


  <div class="main-content">
    <app-header
      [establishments]="establishmentRef$ | async"
      [selectedEstablishmentId]="(selectedEstablishment$ | async)?.detail?.id"
      [currentSchoolYear]="currentSchoolYear$ | async"
      [userName]="userName"
      (schoolChanged)="selectedSchoolChanged($event)"
      (schoolYearChanged)="selectedSchoolYearChanged($event)"
      (logoutClicked)="logout()">
    </app-header>

    <div class="content-area">
      <ng-content></ng-content>
    </div>
  </div>
</div>